import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { api } from '../utils/api';

export default function Setup2FA() {
  const navigate = useNavigate();
  const location = useLocation();
  const forced = location.state?.forced || false;
  const [step, setStep] = useState(1);
  const [secret, setSecret] = useState('');
  const [qrCode, setQrCode] = useState('');
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // If accessed directly without a token, redirect to login
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
    }
  }, [navigate]);

  const generateQR = async () => {
    setLoading(true);
    try {
      const result = await api.post('/auth/setup-2fa', {});
      setSecret(result.secret);
      setQrCode(result.qrCode);
      setStep(2);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const verify = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/verify-2fa', { secret, totpCode: code });
      // Clear temp token and send to login for full auth with 2FA code
      localStorage.removeItem('token');
      navigate('/login', { state: { setup2FAComplete: true } });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: '#0f1117' }}>
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 mb-2">
            <div className="w-9 h-9 rounded-lg flex items-center justify-center font-bold text-lg" style={{ backgroundColor: '#FFB800', color: '#0f1117' }}>E</div>
            <h1 className="text-2xl font-bold text-white tracking-wide">ENCOM TOOLS</h1>
          </div>
          <p className="text-sm" style={{ color: 'rgba(255,255,255,0.4)' }}>Configura la verificación en dos pasos</p>
        </div>

        {forced && (
          <div className="text-sm px-4 py-3 rounded-lg mb-4" style={{ backgroundColor: '#FFF8E1', color: '#795548', border: '1px solid #FFE082' }}>
            Tu administrador requiere autenticación en dos pasos. Configúrala para poder acceder.
          </div>
        )}

        <div className="bg-white rounded-2xl p-6 shadow-2xl">
          {error && <div className="text-sm px-3 py-2 rounded-lg mb-4" style={{ backgroundColor: '#fef2f2', color: '#dc2626' }}>{error}</div>}

          {step === 1 && (
            <div>
              <p className="text-sm text-gray-600 mb-4">
                Necesitarás una app de autenticación como Google Authenticator o Authy.
              </p>
              <button onClick={generateQR} disabled={loading}
                className="btn-accent w-full text-sm px-4 py-2.5 rounded-lg">
                {loading ? 'Generando...' : 'Generar código QR'}
              </button>
            </div>
          )}

          {step === 2 && (
            <div>
              <p className="text-sm text-gray-600 mb-4">Escanea este QR con tu app de autenticación:</p>
              {qrCode && <img src={qrCode} alt="QR Code" className="mx-auto mb-4 w-48 h-48" />}
              <p className="text-xs text-gray-400 mb-4 break-all">Clave manual: {secret}</p>

              <form onSubmit={verify}>
                <label className="block text-sm font-medium text-gray-700 mb-1">Código de verificación</label>
                <input
                  type="text"
                  value={code}
                  onChange={e => setCode(e.target.value)}
                  placeholder="123456"
                  maxLength={6}
                  className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm text-center tracking-widest mb-4 focus:outline-none focus:ring-2"
                  autoFocus
                />
                <button type="submit" disabled={loading || code.length < 6}
                  className="btn-accent w-full py-2.5 rounded-lg text-sm">
                  {loading ? 'Verificando...' : 'Verificar y activar'}
                </button>
              </form>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
